"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.Divider = void 0;
require("./Divider.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Divider component
 *
 * @method
 * @param { DividerProps } props
 * @returns Divider
 */
const Divider = props => {
  const {
    className,
    direction = defaultProps.direction,
    color = defaultProps.color,
    id,
    ...rest
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-Divider', {
    [`pal-c-Divider--${direction}`]: direction,
    [`pal-c-Divider__color--${color}`]: color
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    role: "presentation",
    "aria-hidden": true,
    className: componentClassName,
    id: id
  }, rest), /*#__PURE__*/_react.default.createElement("span", {
    className: "pal-c-Divider__line"
  }));
};

/**
 * Property type definitions
 * @typedef DividerProps
 * @type {object}
 * @property {string} direction - sets divider direction, horizontal or vertical
 * @property {string} color - sets divider color token from Ulta palette
 * @property {string} className - optional class overrides
 */
exports.Divider = Divider;
const propTypes = exports.propTypes = {
  /**
   * sets divider direction, horizontal or vertical
   */
  direction: _propTypes.default.oneOf(['horizontal', 'vertical']),
  /**
   * sets divider color token from Ulta palette
   */
  color: _propTypes.default.oneOf(['default', 'subtle', 'xsubtle', 'validation', 'notification', 'notification-subtle', 'warning', 'error']),
  /**
   * optional class overrides
   */
  className: _propTypes.default.string
};
const defaultProps = exports.defaultProps = {
  direction: 'horizontal',
  color: 'xsubtle'
};
Divider.propTypes = propTypes;
var _default = exports.default = Divider;